import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { GlobalUtilsService } from 'src/app/global-utils.service';

@Component({
  selector: 'app-info-item',
  templateUrl: './info-item.component.html',
  styleUrls: ['./info-item.component.scss']
})
export class InfoItemComponent implements OnInit, AfterViewInit {
  @Input()
  icon: 'phone' | 'localization' | 'instagram';

  @Input()
  link: string;

  @Input()
  label: string;

  @Input()
  opacity = 1;

  constructor(public globalUtilsService: GlobalUtilsService) {}

  ngOnInit() {}

  ngAfterViewInit() {}
}
